import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Field as HeadlessField } from '@flywire/react-headlessui';
import { cx } from '../../utils';
const Group = forwardRef(({ className, ...rest }, ref) => {
    const classes = cx('flex flex-row', className);
    return _jsx(HeadlessField.Group, { className: classes, ref: ref, ...rest });
});
Group.displayName = 'Group';
export { Group };
//# sourceMappingURL=Group.js.map